import React from 'react';

const Required = () => {
  return <span className="text-primary">&nbsp;*&nbsp;</span>;
};

export default Required;
